<template>
  <select
    :value="$i18n.locale"
    class="px-2 py-1 text-sm font-semibold text-gray-600 bg-transparent border border-gray-400 rounded cursor-pointer hover:border-gray-600"
    @change="onChange"
  >
    <option value="de">
      DE
    </option>
    <option value="en">
      EN
    </option>
    <option value="tr">
      TR
    </option>
  </select>
</template>

<script>
import { setLocale } from '@/plugins/i18n'

export default {
  methods: {
    onChange (e) {
      setLocale(e.target.value)
    }
  }
}
</script>
